import {Component, EventEmitter, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {FormSubmission} from '../../../model/form-submission';
import {Studio} from '../../../model/domain/studio';
import {User} from '../../../model/domain/user';
import {StudioService} from '../../../core/service/studio.service';
import {UserService} from '../../../core/service/user.service';
import {UserViewService} from '../user-view/user.view.service';

@Component({
	selector: 'app-user-new',
	templateUrl: './user-new.component.html',
	styleUrls: ['./user-new.component.scss']
})
export class UserNewComponent implements OnInit {

	result: FormSubmission;
	formState = new EventEmitter<FormSubmission>();
	user: User;
	studios: Studio[];
	studioValue: boolean[];

	constructor(
		private router: Router,
		private userService: UserService,
		private userViewService: UserViewService,
		private studioService: StudioService
	) {}

	ngOnInit(): void {
		this.user = {access: '', active: false, created: 0, email: '', id: 0, lastLogin: 0, modified: 0, name: '', password: '', studios: []};

		this.studioService.getAll().subscribe(studios => {
			this.studios = studios;
			this.studioValue = new Array<boolean>(this.studios.length);

			for (let i = 0; i < studios.length; i++) {
				this.studioValue[i] = false;

				for (const studio of this.user.studios) {
					if (studio.id === studios[i].id) {
						this.studioValue[i] = true;
					}
				}
			}
		});

	}

	save(): void {
		const selected = new Array();

		for (let i = 0; i < this.studios.length; i++) {
			if (this.studioValue[i] === true) {
				selected.push(this.studios[i]);
			}
		}
		this.user.studios = selected;

		this.userService.newUser(this.user).subscribe(
			form => {
				this.result = form;
				this.formState.next(form);

				if (form.success) {
					this.router.navigateByUrl(`/user/${form.object.id}`);
					// this.user.access = this.capitalizeFirstLetter(this.user.access);
				}
			}
		);
	}

	capitalizeFirstLetter(text: string): string {
		return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
	}

}
